
/* ========================================================================== *
 * Created by Iskrzy
 * Training Scripts
 * ========================================================================== */

function setHeaderClass(){
    
    var el = $('.filters-container');
    if(el.length){
        if(el.is(":visible")){
            $('.filters-header').removeClass('opened');
        }
        else { $('.filters-header').addClass('opened'); }
    }
}

function deleteFilter(type,value){
    //console.log('test');
    if(type==='spfilter'){
        $.each($(".spfilter option:selected"), function(){
            if($(this).val()===value){
                $(this).prop("selected", false);
                $(this).parent().selectpicker('refresh');
                updateFilters();
                getClubClasses();
            }
        });
    } else if(type==='dates'){
                $('#houre-filter').val('');
                $("#slider-club-calendar").slider("option", "values", [0,1440]);
                $("#slider-club-calendar").trigger('change');
                updateFilters();
                getClubClasses();
    }
    
}

function updateFilters(){
    //console.log('test1');
    $('#active-filters').html('');
    var hfilter = $('#houre-filter');
    var targets = new Array();
    var tempArr = new Array();
    
    $.each($(".spfilter option:selected"), function(){
                var t = new Array();
                t['type'] = 'spfilter';
                t['value'] = $(this).val();
                t['name'] = $(this).text();
            
            if(t.value!='' && $.inArray(t.value,tempArr)== -1){
                targets.push(t);
                tempArr.push(t.value);
            }
    });
    
    if(hfilter.length && hfilter.val()!=''){
        var t = new Array();
        t['type'] = 'dates';
        t['value'] = hfilter.val();
        t['name'] = hfilter.val();
        
        if(t.value!='' && $.inArray(t.value,tempArr)== -1){
                targets.push(t);
                tempArr.push(t.value);
        }
    }
    //console.log(tempArr);
    //console.log(targets);
    if(targets.length){
        //console.log('o1');
        $.each(targets, function(index,ele){
            if(index!==''){
                //console.log('append');
                var el = '<a class="btn btn-medium-lightgrey active-filter-el" onclick="deleteFilter(\''+ele.type+'\',\''+ele.value+'\');$(this).remove();">'+ele.name+'\&nbsp;&nbsp;<img src="/wp-content/themes/Calypso/assets/images/x-icon-white.png" alt="x" /></a>';
                $('#active-filters').append(el);
            }
        });
    }
}


function getClubClasses(){
     updateFilters();
     showLoader(1);
     $scavresults.fadeOut().html('');

     var form = $('#search-class-form');
     $.post('/api/clubschedule/',
           form.serialize(),
                function (data, Status, jqXHR) {
                    if (Status === 'success') {
                      $scavresults.html(data).fadeIn();
                       if($('.select-day-calendar').length){
                            $('.select-day-calendar').selectpicker();
                            
                            $('.select-day-calendar').on('change', function(e){
                                var id = $(this).val();
                                $('a[href="' + id + '"]').tab('show');
                            });
                       }
                       //center namses
                       var elements = $('div.schedule-class-cell');
                       if(elements.length>0){
                               elements.each(function(index,item){
                                cc = $(item).find('div.class');
                                if(cc.length>0){
                                   cc.each(function(ccindex,ccitem){ 
                                       ccd = $(item).find('div.classinfo-div');
                                       if(ccd.length>0){
                                            posInHalfOf(ccd,cc,0,0);
                                       }
                                   });
                                }
                            });
                        }
                       hideLoader(1);    
                    }
                    else {
                         hideLoader(1);
                    }
                }
    );
}

function clearForm(){
   
  $('#search-class-id').val('');
  $('#search-class-id').selectpicker('refresh');
  
  $('#search-trainer-id').val('');
  $('#search-trainer-id').selectpicker('refresh');
  
  $('#search-purpose-id').val('');
  $('#search-purpose-id').selectpicker('refresh');
   
  $("#slider-club-calendar").slider("option", "values", [0,1440]);
  $('#houre-filter').val();
  $("#slider-club-calendar").trigger('change');
  
  getClubClasses();
  
}

function HideACForm(){
    $scavresults.hide().html('');
    $scavcont.hide();
    //reset date?
    //reset houres
    //reset club?
}



function showClassesDetails(item){
    
    var container = $('.container');
    var item = $(item);
    var hover = item.find(".hover");
    
    var expanded = $('.class.expanded');
    if(expanded.length) closeClassesDetails();
    
    item.addClass('expanded');
    
    if(hover.width()>container.width()){
        hover.css('width', container.width());
        hover.css('left', '0px');
    }
    
    
    var acel  = item.offset();
    var accont  = container.offset();


    if(acel.left+hover.width()>accont.left+container.width()){
        hover.css('left', (accont.left+container.width()-acel.left-hover.width())+'px');
    }
    
    hover.show();
    
}

function closeClassesDetails(perm)
{
    var perm =1;
    var item = $('.class.expanded');
    var hovers = item.find(".hover");
    if(hovers.length>0) hovers.hide();
    item.removeClass('expanded');
    
    if(perm) return false;
}

function setShowType(type){
    //update print options!
    showType = $('#showType');
    
    if(type && type !='undefined' && type!='null'){
        if(type=='day'){
            $scavresults.removeClass('showweek');
            showType.val('day');
            $('.day-week-show-button').find('span.show-day').hide();
            $('.day-week-show-button').find('span.show-week').show();
            $('.day-week-show-button').find('img.plus').show();
            $('.day-week-show-button').find('img.minus').hide();
        }
        else { 
            $scavresults.addClass('showweek');
            showType.val('week');
            $('.day-week-show-button').find('span.show-week').hide();
            $('.day-week-show-button').find('span.show-day').show();
            $('.day-week-show-button').find('img.plus').hide();
            $('.day-week-show-button').find('img.minus').show();
        }
        
        getClubClasses();
        
    }
}

function showHideSubstitutions(){
    $trigger = $('#showsubstitutiononly');
    $rc = $('.results-container');

    if($rc.length){
        if($trigger.hasClass('active')){
            $rc.find('.hours.nosubsts').show();
            $rc.find('.schedule-row.nosubsts').show();
            $rc.find('.class.nosubsts').show();
            $trigger.removeClass('active');
        }
        else {
            $rc.find('.hours.nosubsts').hide();
            $rc.find('.class.nosubsts').hide();
            $rc.find('.schedule-row.nosubsts').hide();
            $trigger.addClass('active');
        }
    }
}


function getPeriodSchedule(timeperiod){
  
  if(timeperiod && timeperiod !='undefined' && timeperiod!='null'){
                var actdate = moment($('#datestart').val(),"DD-MM-YYYY");
                //var dateto = moment($('#dateend').val());
                
                if(!actdate.isValid()) return false;
                
                if(timeperiod=='next'){
                    var newperiodfrom = actdate.clone().add(7,'days').format('DD-MM-YYYY');
                    var newperiodto = actdate.clone().add(13,'days').format('DD-MM-YYYY');
                    
                }
                else if(timeperiod=='prev'){
                    var newperiodto = actdate.clone().subtract(1,'days').format('DD-MM-YYYY');
                    var newperiodfrom = actdate.clone().subtract(7,'days').format('DD-MM-YYYY');
                    
                    var compareD = actdate.clone();
                    var isAfter = compareD.isAfter(moment());
                    if(!isAfter) return false;
                    
                }
                
                if(newperiodto && newperiodto!='undefined' && newperiodfrom && newperiodfrom!='undefined'){
                    $('#datestart').val(newperiodfrom);
                    $('#schedule-time-period').text(''+newperiodfrom+' - '+newperiodto);
                }//alert(moment($('#schedule-week').val(),"DD-MM-YYYY").add(7,'days').format('DD-MM-YYYY'));
            }
    getClubClasses();
}


$(document).ready(function(){
    
    $scavform = $('#search-class-form');
    $scavresults = $('#scav-results');
    ///$filters = new Array();
    
      $('#classes-select').on('changed.bs.select', function (e) {
           getClubClasses();
      }); 
      
      $('#purpose-select').on('changed.bs.select', function (e){
           getClubClasses();
      }); 
      
      $('#search-trainer-id').on('changed.bs.select', function (e){
           getClubClasses();
      }); 
      
      
      $("#slider-club-calendar").slider({
           range: true,
            min: 0,
            max: 1440,
            step: 60,
            values: [0, 1440],
            slide: function (e, ui) {

                var hours1 = Math.floor(ui.values[0] / 60);
                var minutes1 = ui.values[0] - (hours1 * 60);

                if (hours1.length == 1) hours1 = '0' + hours1;
                if (minutes1.length == 1) minutes1 = '0' + minutes1;
                if (minutes1 == 0) minutes1 = '00';

                var hours2 = Math.floor(ui.values[1] / 60);
                var minutes2 = ui.values[1] - (hours2 * 60);

                if (hours2.length == 1) hours2 = '0' + hours2;
                if (minutes2.length == 1) minutes2 = '0' + minutes2;
                if (minutes2 == 0) minutes2 = '00';

                var start = ''+hours1+':'+minutes1;//+':00';
                if(hours2=='24'){ var end='23:59'}
                else var end = ''+hours2+':'+minutes2;//+':00';
                
                $('#start-time').val(start);
                $('#end-time').val(end);
                //$(this).children(".ui-slider-handle").eq(0).html('<span class="val">' + hours1 + ':' + minutes1 + '</span>');
                //$(this).children(".ui-slider-handle").eq(1).html('<span class="val">' + hours2 + ':' + minutes2 + '</span>');
                $(this).children(".ui-slider-handle").eq(0).html('<span class="val">' + hours1 + '</span>');
                $(this).children(".ui-slider-handle").eq(1).html('<span class="val">' + hours2 +'</span>');

            },
            change: function (e, ui) {
                //alert('a');
                var hours1 = Math.floor(ui.values[0] / 60);
                var minutes1 = ui.values[0] - (hours1 * 60);

                if (hours1.length == 1) hours1 = '0' + hours1;
                if (minutes1.length == 1) minutes1 = '0' + minutes1;
                if (minutes1 == 0) minutes1 = '00';

                var hours2 = Math.floor(ui.values[1] / 60);
                var minutes2 = ui.values[1] - (hours2 * 60);

                if (hours2.length == 1) hours2 = '0' + hours2;
                if (minutes2.length == 1) minutes2 = '0' + minutes2;
                if (minutes2 == 0) minutes2 = '00';


                var start = ''+hours1+':'+minutes1;//+':00';
                if(hours2=='24'){ var end='23:59'}
                else var end = ''+hours2+':'+minutes2;//+':00';

                $('#start-time').val(start);
                $('#end-time').val(end);
                $(this).children(".ui-slider-handle").eq(0).html('<span class="val">' + hours1 +'</span>');
                $(this).children(".ui-slider-handle").eq(1).html('<span class="val">' + hours2 +'</span>');

            },
            stop: function(e,ui) { 
               //autosearch
                var dates = $('#start-time').val()+'-'+$('#end-time').val();
                $('#houre-filter').val(dates);
                updateFilters();
                getClubClasses();
            },
            create: function (e, ui) {
                $(this).children(".ui-slider-handle").eq(0).html('<span class="val">0</span>');
                $(this).children(".ui-slider-handle").eq(1).html('<span class="val">24</span>');
                $('#start-time').val('00:00');
                $('#end-time').val('23:59');
            }
        });
        
        $("#datestart").datepicker({
                       // startDate: '+0d',
                        //todayHighlight: true,
                        useCurrent: true,
                        format: "dd/mm/yyyy",
                        showWeek: true,
                        corientation: 'auto',
                        autoclose: true,
                        firstDay: 1,
                        
                    }).on('changeDate', function(e){
                            $("#schedule-week").datepicker("setDate", e.date);
                            //$("#dateto").datepicker("setDate", "+1d");
                             getClubClasses();
                    });
      
      
      
      $(document).on("click", ".printSchedule", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    el = $(this);
                    var ref = el.attr("ref");
                    var refday = el.attr("refday");
                    //alert(refday);
                   
                   if(ref && ref==="day"){
                      if(refday && refday!==''){
                           var printref="#shp-"+refday;
                      }
                      else var printref = '#printAll';
                   }
                    
                   if(ref && ref=="week")
                        var printref = '#printAll';
                
                                     
                    $(printref).printThis({
                        debug: false,               // show the iframe for debugging
                        importCSS: true,            // import page CSS
                        importStyle: true,          // import style tags
                        printContainer: true,       // grab outer container as well as the contents of the selector
                        loadCSS: "/wp-content/themes/Calypso/club_schedule_print.css", // path to additional css file - us an array [] for multiple
                        pageTitle: "",              // add title to print page
                        removeInline: false,        // remove all inline styles from print elements
                        printDelay: 333,            // variable print delay; depending on complexity a higher value may be necessary
                        header: null,               // prefix to html
                        formValues: true            // preserve input/form values
                    });
                });
      
           
       $(document).on("click", ".class", function (e) {
           var classs = $(this);
           var hover = classs.find('.hover');
           if(hover){
                if($(classs).hasClass('expanded'))
                    closeClassesDetails();
                else 
                    showClassesDetails(classs);
           }
       });
       
       $(document).on("click", ".hover-close", function (e) {
            closeClassesDetails();
            e.stopPropagation();
       });
       
       $(document).on("click", "#showsubstitutiononly", function (e) {
            showHideSubstitutions();
            //e.stopPropagation();
       });
            
       getClubClasses();
   });
